export const SAMPLE_REPORT_LIST_ID = 'SgnbT7'
export const WHITEPAPER_LIST_ID = 'XRewW8'
